export default __webpack_public_path__ + "static/media/life-approach.f0afb8a2.png";